import { createContext, createSignal, onMount, Show, useContext } from "solid-js";
import { useLocation, useNavigate } from "@solidjs/router";
import SiteLoader from "@/components/ui/SiteLoader";
import { me } from "../requests/auth";

const AuthContext = createContext();

export default function AuthProvider(props) {
  const [user, setUser] = createSignal(null);
  const [isAuthenticated, setIsAuthenticated] = createSignal(false);
  const [isAuthenticating, setIsAuthenticating] = createSignal(false);

  const navigate = useNavigate();
  const location = useLocation();

  const loadCurrentUser = async () => {
    try {
      const response = await me();
      setCurrentUser(response.user);
    } catch (error) {
      throw error;
    }
  };

  onMount(async () => {
    setIsAuthenticating(true);
    setIsAuthenticated(false);
    try {
      await loadCurrentUser();
    } catch (error) {
      if (!location.pathname.includes("auth")) {
        navigate("/auth/login");
      }
    } finally {
      setIsAuthenticating(false);
    }
  });

  const setCurrentUser = (user) => {
    setIsAuthenticated(true);
    setUser(user);
  };

  const removeCurrentUser = () => {
    setIsAuthenticated(false);
    setUser(null);
  };

  const cleanupUserData = () => {
    navigate("/", { replace: true });
    window.location.reload();
  };

  return (
    <AuthContext.Provider value={{
      isAuthenticated,
      isAuthenticating,
      currentUser: user,
      setCurrentUser,
      loadCurrentUser,
      removeCurrentUser,
      cleanupUserData
    }}>
      <Show when={!isAuthenticating()} fallback={<SiteLoader />}>
        {props.children}
      </Show>
    </AuthContext.Provider>
  );
}

export const useAuthentication = () => useContext(AuthContext);
